import { render, staticRenderFns } from "./onlineDoc.vue?vue&type=template&id=a5df245e&scoped=true"
import script from "./onlineDoc.vue?vue&type=script&lang=js"
export * from "./onlineDoc.vue?vue&type=script&lang=js"
import style0 from "./onlineDoc.vue?vue&type=style&index=0&id=a5df245e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_a0b2c34ca8cb6aec36211e2e48fb208b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5df245e",
  null
  
)

export default component.exports